<template>
    <div>
        <div class="balanca-modal-container" v-if="weighed">
            <div class="balanca-modal">
                <span class="list-title" v-text="getString('itens_pesaveis')"></span>
                <div class="balanca-container">
                    <div class="balanca-scroll">
                        <div class="balanca-item" v-for="(item, key) in weighed" :key="key">
                            <img :src="getImagesURL(item, 'productImages') || junk" :alt="item.productName">
                            <label v-text="item.productCode + ' ' + item.productName"></label>
                            <CircleButton  class="edit_button" :icon="delete_white" :evetName="'removeItem'" @removeItem="removeItem(key)"></CircleButton>
                        </div>
                        <div class="balanca-item">
                            <img :src="junk">
                            <select :name="'weigheditem'" v-model="option">
                                <option v-for="(option, itemKey) in getOptions()" :value="option" :key="itemKey" v-text="option.productCode +' '+ option.productName"></option>
                            </select>
                            <CircleButton  class="edit_button" :icon="add_white" :evetName="'addNewRow'" @addNewRow="addNewRow()"></CircleButton>
                        </div>
                    </div>
                </div>
                <DefaultButton :text="getString('confirmar')" @defaultBtnClick="saveBalancaMode"></DefaultButton>
            </div>

        </div>
    </div>
</template>

<script>
import CircleButton from '@/components/CircleButtonWithNamedEvent'
import DefaultButton from '@/components/DefaultButton'
import balancaController from './BalancaMode.js'
import LocaleController from '@/assets/controllers/LocaleController'
// import Util from '@/assets/libs/util'

export default {
    name: 'BalancaModeConfig',
    props: ['isBalanca', 'config'],
    components: {
        CircleButton,
        DefaultButton
    },
    data () {
        return {
            edit_white: require('../../../static/icons/edit_white.svg'),
            delete_white: require('../../../static/icons/delete_white.svg'),
            add_white: require('../../../static/icons/plus_white.svg'),
            junk: require('../../../static/icons/junk-icon.png'),
            isEditing: false,
            options: [],
            weighed: [],
            option: {}
        }
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        openBalancaModal: async function () {
            this.isEditing = true
            let emptyOptions = this.options && this.options.length === 0
            if (emptyOptions) {
                await this.loadOptions()
            }
        },
        getImagesURL: function (prod, prop) {
            let url = this.config.urlIMGOdhenInterface
            let uri = (prod[prop] && prod[prop].small)
            return uri && (url + uri)
        },
        loadOptions: async function () {
            this.options = await balancaController.loadData(this.config)
        },
        removeItem: function (key) {
            this.weighed = this.weighed.filter((i, k) => k !== key)
        },
        addNewRow: function () {
            if (this.option && this.option.productCode) {
                this.weighed.push(this.option)
                this.option = {}
            }
        },
        isEmpty: function (arr) {
            return (arr && arr.at(-1) && !arr.at(-1).productCode) || (arr && arr.length === 0)
        },
        saveBalancaMode: function () {
            this.isEditing = false
            if (this.isEmpty(this.weighed)) {
                this.weighed = this.weighed.filter((i) => i.productCode)
            }
            this.$emit('saveBalancaMode', this.weighed)
        },
        getOptions: function () {
            return this.options.filter(o => {
                return this.weighed.findIndex(e => e.productCode === o.productCode) === -1
            })
        }
    },
    async mounted () {
        this.weighed = this.config.weighed || []
        if (this.weighed && this.weighed.length === 0) {
            this.isEditing = true
            await this.loadOptions()
        }
        this.openBalancaModal()
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import (reference) url("../../assets/common.less");
.balanca-modal-container {
    .full;
    z-index: 5;
    background: rgba(0,0,0,0.8);
    .balanca-modal {
        position: relative;
        display: block;
        top: 50%;
        left: 50%;
        height: 650px;
        transform: translate(-50%, -70%);
        background: white;
        border-radius: 5px;
        overflow: hidden;
        width: 800px;
        .list-title {
            font-weight: bold;
            position: relative;
            display: block;
            padding: 10px 15px;
            color: white;
            background: var(--primary-color);
        }
        .balanca-container {
            max-height: 500px;
            overflow: auto;
            .balanca-scroll {
                padding: 15px 0;
                min-height: 470px;
                .balanca-item {
                    display: grid;
                    padding-right: 5px;
                    grid-template-columns: 10% 80% 10%;
                    img {
                        position: relative;
                        max-width: 100%;
                    }
                    select {
                        width: calc(100% - 15px);
                        height: 50px;
                        margin: auto;
                    }
                    .edit_button {
                        margin: auto;
                    }
                }
            }
        }
        .button-default {
            margin: auto;
            height: 5rem;
        }
    }
}
@media (min-width: 699px) and (max-width: 1025px) { //@tablet
    .balanca-modal-container {
        .balanca-modal {
            width: 600px;
            .balanca-container {
                .balanca-scroll {
                    padding: 15px 0;
                    min-height: 470px;
                    .balanca-item {
                        display: grid;
                        padding-right: 5px;
                        grid-template-columns: 15% 70% 15%;
                        select {
                            height: 40px;
                        }
                        .edit_button {
                            margin: auto;
                        }
                    }
                }
            }
            .button-default {
                margin: auto;
                height: 4rem;
            }
        }
    }
}
@media (max-width: 698px) {
    .balanca-modal-container {
        .balanca-modal {
            width: 400px;
            transform: translate(-50%, -55%);
            height: 500px;
            .balanca-container {
                .balanca-scroll {
                    padding: 15px 0;
                    min-height: 370px;
                    .balanca-item {
                        display: grid;
                        padding-right: 5px;
                        grid-template-columns: 15% 70% 15%;
                        select {
                            height: 40px;
                        }
                        .edit_button {
                            margin: auto;
                            height: 40px;
                            width: 40px;
                        }
                    }
                }
            }
            .button-default {
                margin: auto;
                height: 2.5rem;
            }
        }
    }
}
@media (orientation: landscape) {
        .balanca-modal-container {
        .balanca-modal {
            width: 700px;
            position: absolute;
            margin: 120px 0;
            .balanca-container {
                .balanca-scroll {
                    padding: 15px 30px;
                    min-height: 470px;
                    .balanca-item {
                        display: grid;
                        padding: 0 0;
                        margin: 10px 0;
                        grid-template-columns: 15% 70% 15%;
                        justify-content: center;
                        align-items: center;
                        border: solid 1px rgba(0, 0, 0, 0.253);
                        border-radius: 10px;
                        select {
                            height: 40px;
                        }
                        .edit_button {
                            margin: auto;
                        }
                        label {
                            text-align: center;
                        }
                        img {
                            border-top-left-radius: 10px;
                            border-bottom-left-radius: 10px;
                        }
                    }
                }
            }
            .button-default {
                margin: auto;
                height: 4rem;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/BalancaModeConfig/index.vue